// extracted by mini-css-extract-plugin
module.exports = {"header":"HistoryHeader_header___ELqn","header__container":"HistoryHeader_header__container__pAwCt"};